<template>
    <van-cell-group >
        <van-cell title="地址是否与抵押物地址一致:"  :value="formData.address" />
        <van-cell title="成员人数:"  :value="formData.member" />
        <van-cell title="婚姻状况:" :value="formData.maritalStatus" />
        <van-cell title="从事行业、经营、收入情况等:" :value="formData.other" />
        <van-cell title="客户是否有当前逾期:" :value="formData.overdue"/>
        <van-cell v-if="formData.overdue==='有'" title="逾期原因:" :value="formData.overdueReason" />
        <van-cell title="客户是否有担保信息:" :value="formData.guarantee" />
        <van-cell title="资金用途、转贷目的:" :value="formData.use" />
        <van-cell title="异常与风险提示:" :value="formData.risks" />
    </van-cell-group>
</template>

<script>
    import { debounce} from 'lodash'
    import {saveFormData,getFormData} from '@/api/foreclosure'
    export default {
        name: 'interview_view',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                formData:{}
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            loadData() {
                const self = this
                let params = {
                    applyId: this.applyId,
                    formModule: 'F_InterviewView'
                }
                getFormData(params).then(res => {
                    let data={}
                    if (res.success) {
                        res.data!=null&&res.data.forEach((item,index)=>{
                            data[item.ext]=item.info
                        })
                        debounce(() => {
                            self.formData=data
                        },200)()
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
